/* eslint-disable camelcase */
import React from "react"
import { auditShape } from "utils/propTypeShapes"
import { AuditedUser } from "shared/audits"

const ConversationReopenedAuditItemDetails = ({ audit }) => {
  const { conversation } = audit
  const { title } = conversation

  return (
    <div>
      <span>
        <AuditedUser audit={audit} /> reopened the
        conversation titled <span className="font-semibold">{title}</span>.
      </span>
    </div>
  )
}

ConversationReopenedAuditItemDetails.propTypes = {
  audit: auditShape.isRequired,
}

export default ConversationReopenedAuditItemDetails
